export enum GroupType {
  SUBSCRIPTIONS = 'SUBSCRIPTIONS',
  CONSENTS = 'CONSENTS',
}

export enum ItemStatus {
  ON = 'ON',
  OFF = 'OFF',
  PENDING = 'PENDING',
}

export interface ConsentHubTab {
  key?: string | 'root';
  title?: string;
  items: Record<string, ItemStatus | undefined>;
}

export interface ConsentHubGroup {
  key: string;
  title: string;
  description: string;
  type: GroupType;
  tabs: Record<string, ConsentHubTab>;
}

export interface ConsentHubConsentAndSubscriptionResponse {
  email?: string;
  groups?: Record<string, ConsentHubGroup>;
  downForMaintenanceMessage?: string;
  hid?: string;
}

export interface ConsentHubConsentRequest {
  key: string;
  displayedText: string;
  granted: boolean;
}

export interface ConsentHubSubscriptionRequest {
  key: string;
  subscribed: boolean;
}

export interface ConsentHubConsentAndSubscriptionRequest {
  hid: string;
  site?: string;
  formUrl?: string;
  consents?: ConsentHubConsentRequest[];
  subscriptions?: ConsentHubSubscriptionRequest[];
  source?: string;
  action?: string;
}

export interface ConsentHubConsentResponse {
  downForMaintenanceMessage?: string;
}
